// src/pages/Motors.jsx
import React from "react";
import MotorsSection from "../homeComponents/home/MotorsSection";
import ConsultancySection from "../homeComponents/home/ConsultancySection";

const Motors = () => (
  <section className="pb-24 md:pb-16">
    <MotorsSection />
    <ConsultancySection />
  </section>
);

export default Motors;